(function () {
  'use strict';

  var CARD = '.evm-ws-card[data-pid]';
  var PRICE = '.ws-card__price';
  var BADGE_CLASS = 'mx-promo-badge';

  var cache = {};
  var inFlight = false;
  var queued = false;

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol',
      }).format(cents / 100);
    } catch (e) {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    }
  }

  function heroCents(price, pct) {
    if (!(pct > 0) || pct >= 100) return price;
    return Math.floor((price * (100 - pct)) / 100);
  }

  function cardsNeedingWork() {
    var out = [];
    var nodes = document.querySelectorAll(CARD);
    for (var i = 0; i < nodes.length; i++) {
      var card = nodes[i];
      var id = card.getAttribute('data-pid');
      if (!id) continue;
      out.push(card);
    }
    return out;
  }

  function unknownIds(cards) {
    var ids = [];
    for (var i = 0; i < cards.length; i++) {
      var id = cards[i].getAttribute('data-pid');
      if (id && !(id in cache) && ids.indexOf(id) === -1) ids.push(id);
    }
    return ids;
  }

  function apply(card) {
    var entry = cache[card.getAttribute('data-pid')];
    if (!entry) return;

    var priceEl = card.querySelector(PRICE);
    if (!priceEl) return;

    if (!(entry.pct > 0)) return;

    var hero = heroCents(entry.price, entry.pct);
    var reference = entry.compare > hero ? entry.compare : entry.price;

    var html =
      '<span class="mx-promo-price">' + money(hero) + '</span>' +
      (reference > hero ? ' <s class="mx-promo-compare">' + money(reference) + '</s>' : '');

    if (priceEl.innerHTML !== html) {
      priceEl.innerHTML = html;
    }
    priceEl.dataset.mxPromoWrote = '1';

    if (!card.querySelector('.' + BADGE_CLASS)) {
      var badge = document.createElement('span');
      badge.className = BADGE_CLASS;
      badge.textContent = 'Extra ' + entry.pct + '% Off';
      card.insertBefore(badge, card.firstChild);
    }
  }

  function applyAll(cards) {
    for (var i = 0; i < cards.length; i++) apply(cards[i]);
  }

  function run() {
    if (inFlight) { queued = true; return; }

    var cards = cardsNeedingWork();
    if (!cards.length) return;

    var ids = unknownIds(cards);
    if (!ids.length) { applyAll(cards); return; }

    inFlight = true;
    var query = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'search'
      : '/search';

    fetch(url + '?section_id=promo-map&type=product&q=' + encodeURIComponent(query))
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var node = parsed.querySelector('[data-mx-promo-map]');
        var rows = node ? JSON.parse(node.textContent) : [];
        for (var i = 0; i < rows.length; i++) cache[String(rows[i].id)] = rows[i];
        for (var j = 0; j < ids.length; j++) {
          if (!(ids[j] in cache)) cache[ids[j]] = { pct: 0, price: 0, compare: 0 };
        }
        applyAll(cardsNeedingWork());
      })
      .catch(function () {
        for (var k = 0; k < ids.length; k++) cache[ids[k]] = { pct: 0, price: 0, compare: 0 };
      })
      .then(function () {
        inFlight = false;
        if (queued) { queued = false; run(); }
      });
  }

  var debounce = null;
  function schedule() {
    clearTimeout(debounce);
    debounce = setTimeout(run, 120);
  }

  function start() {
    schedule();
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });

    [600, 1800, 4000].forEach(function (ms) { setTimeout(run, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
